import { useAuthStore } from "@/store/authStore";
import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

interface ProtectedRouteProps {
	children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
	const { isLoggedIn, isTokenChecked } = useAuthStore();
	const navigate = useNavigate();

	useEffect(() => {
		if (isTokenChecked && !isLoggedIn) {
			navigate({ to: "/login" });
		}
	}, [isLoggedIn, isTokenChecked, navigate]);

	// Show loading while checking token
	if (!isTokenChecked) {
		return (
			<div className="flex h-screen items-center justify-center">
				<div className="text-center">
					<div className="mb-4 text-2xl font-bold">PhilTrade</div>
					<div className="text-lg">Loading...</div>
				</div>
			</div>
		);
	}

	// Redirect to login if not authenticated
	if (!isLoggedIn) {
		return null;
	}

	return <>{children}</>;
};

export default ProtectedRoute;
